import { AUSZEICHNUNGEN, type Art } from '../lib/auszeichnung'
import { useTexte } from '../texte'

/**
 * The four marks as buttons -- in one place (1.69.0).
 *
 * From use: „heute möglich: Durchgestrichen, Kapitälchen; zusätzlich soll noch
 * Fett und Italics angeboten werden […] im Übrigen sollte das auch im
 * Änderungsmodus funktionieren."
 *
 * **The machinery could do all four since the beginning** (`auszeichnung.ts`,
 * `reichtext.ts`). What was missing were two buttons: the composer filtered
 * the list down to `durch` and `kapitael`, and the comment beside it said why
 * -- „Fett und Kursiv holt man sich in Apples Menü". That menu exists and
 * `lese()` does read its `<b>` and `<i>`, so the sentence was not wrong; it
 * was just not enough. Whoever wants the mark should find it where the other
 * two stand.
 *
 * **Jeder Knopf sieht aus, was er tut** -- die vier Klassen
 * (`auszeichnen__knopf--fett` und die drei daneben) gab es die ganze Zeit,
 * auch für die beiden, die nicht dastanden.
 *
 * **Und der Knopf darf den Fokus nicht nehmen.** Mit dem Fokus ginge die
 * Markierung, und danach wäre nichts mehr auszuzeichnen -- deshalb
 * `preventDefault` am `mousedown` und nicht am Klick.
 */
export function Auszeichnungsknoepfe({
  lege,
  aus = false,
  klasse,
}: {
  lege: (art: Exclude<Art, 'text'>) => void
  /** Ohne Markierung gibt es nichts auszuzeichnen -- dann stehen sie grau da. */
  aus?: boolean
  /** Der Knopfstil der Umgebung: rund in der Eingabezeile, eckig im Blatt. */
  klasse: string
}) {
  const t = useTexte()

  return (
    <>
      {AUSZEICHNUNGEN.map((a) => {
        const wort = t.chat.auszeichnung[a.art]
        return (
          <button
            key={a.zeichen}
            type="button"
            className={`${klasse} auszeichnen__knopf--${a.art}`}
            title={wort.name}
            aria-label={wort.name}
            disabled={aus}
            data-auszeichnung={a.art}
            onMouseDown={(event) => event.preventDefault()}
            onClick={() => lege(a.art)}
          >
            {wort.kurz}
          </button>
        )
      })}
    </>
  )
}
